module.exports = __webpack_public_path__ + "static/media/flow_trade.a5024242.svg";